import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <footer className="footer mgt-medium">
                <div className="content has-text-centered">
                    <p>
                        <strong>Phones API App.</strong> by <a target="_blank" rel="noreferrer" href="https://ohilari.dev">Oriol Hilari</a> 🙋🏼‍♂️.
                        Back End code is <a target="_blank" rel="noreferrer" href="https://github.com/hilaring/phone-api">here </a> 
                        and the Front End code is <a target="_blank" rel="noreferrer" href="https://github.com/hilaring/phone-app">here</a>.
                    </p>
                </div>
            </footer>
        )
    }
}
